/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Low_Dry_Sawfish_TypeInputs */

const fr_low_dry_sawfish_type = /** @type {(inputs: Low_Dry_Sawfish_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom mis à jour`)
};

/**

* @param {Low_Dry_Sawfish_TypeInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const low_dry_sawfish_type = /** @type {((inputs?: Low_Dry_Sawfish_TypeInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Low_Dry_Sawfish_TypeInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_low_dry_sawfish_type(inputs)
});